import * as Yup from "yup";

export const addNewCarsSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  // shortDescription: Yup.string().required("Short Description is required"),
  // description: Yup.string().required("Description is required"),
  // modalYear: Yup.number()
  //   .nullable()
  //   .required("Model Year is required")
  //   .min(1900, "Year must be after 1900")
  //   .max(new Date().getFullYear(), "Year cannot be in the future"),
  // miles: Yup.number()
  //   .nullable()
  //   .required("Miles are required")
  //   .min(0, "Miles cannot be negative"),
  // enginePower: Yup.number()
  //   .nullable()
  //   .required("Engine Power is required")
  //   .min(0, "Engine power must be positive"),
  // color: Yup.string().required("Color is required"),
  // previousOwner: Yup.number()
  //   .nullable()
  //   .required("Previous owner count is required")
  //   .min(0, "Cannot be negative"),
  // insuranceGroup: Yup.number()
  //   .nullable()
  //   .required("Insurance Group is required"),
  // fuelTypes: Yup.string().required("Fuel type is required"),
  // gearTypes: Yup.string().required("Gear type is required"),
  // featuredImage: Yup.string().required("Featured Image is required"),
  // imageGallery: Yup.string().required("Image Gallery is required"),
});
export const contactSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().required("Email is required").email("Email is invalid"),
  phoneNumber: Yup.string().required("Phone number is required"),
  option: Yup.string().required("Option is required"),
  message: Yup.string().required("Message is required"),
});

export const PartsAppSchema = [
  Yup.object({
    enquiryRegarding: Yup.string().required("This field is required"),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    phoneNumber: Yup.string()
      .matches(/^[0-9]{10,11}$/, "Enter a valid phone number")
      .required("Phone number is required"),
    postCode: Yup.string().required("Postcode is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
  }),

  Yup.object({
    registrationNumber: Yup.string().required(
      "Registration number is required"
    ),
    vehicleMake: Yup.string().required("Vehicle make is required"),
    vehicleModel: Yup.string().required("Vehicle model is required"),
    externalColor: Yup.string().required("Color is required"),
    vehicleMileage: Yup.number()
      .positive("Mileage must be positive")
      .required("Vehicle mileage is required"),
    estimatedValue: Yup.number()
      .positive("Value must be positive")
      .required("Estimated value is required"),
  }),

  Yup.object({
    externalDefects: Yup.string(),
    internalDefects: Yup.string(),
    otherComments: Yup.string(),
    linkPhotos: Yup.string().url("Enter a valid URL"),
  }),
];

export const carValuationSchema = Yup.object({
  vehicleMake: Yup.string().required("Required"),
  mileage: Yup.string().required("Required"),
  name: Yup.string().required("Required"),
  model: Yup.string().required("Required"),
  year: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email format").required("Required"),
  registrationNumber: Yup.string().required("Required"),
});

export const carPurchaseSchema = Yup.object({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  phone: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email format").required("Required"),
});
export const serviceSchema = Yup.object({
  appointmentDateTime: Yup.date()
    .min(new Date(), "Appointment date must be in the future")
    .required("Appointment Date & Time is required"),
  regPlateNumber: Yup.string().required("Required"),
  name: Yup.string().required("Required"),
  makeYear: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email format").required("Required"),
  phone: Yup.string().required("Required"),
  address: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  zip: Yup.string().required("Required"),
});
